var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../../../public/img/LOGO_preto.png"),"alt":"Profile Photo","width":"50"}})])
}]

export { render, staticRenderFns }